import { combineReducers } from '@reduxjs/toolkit'

import { emptySplitApi } from 'emptySplitApi'

import { accountReducer } from './account/accountSlice'
import { apiHeadersReducer } from './apiHeaders/apiHeadersSlice'
import { areaReducer } from './area/areaSlice'
import { assessmentReducer } from './assessment/assessmentSlice'
import { auditReducer } from './audit/auditSlice'
import { authReducer } from './auth/authSlice'
import { companyReducer } from './company/companySlice'
import { questionSessionReducer } from './questionSession/questionSessionSlice'
import { reportsReducer } from './reports/reportsSlice'
import { statusReducer } from './status/statusSlice'

export const reducer = combineReducers({
  accountReducer,
  areaReducer,
  apiHeadersReducer,
  assessmentReducer,
  auditReducer,
  authReducer,
  companyReducer,
  questionSessionReducer,
  statusReducer,
  reportsReducer,
  [emptySplitApi.reducerPath]: emptySplitApi.reducer,
})
